import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss';
import Box from '@atlaskit/primitives/box';

const SpaceSettingsPageContainerStyles = xcss({
	backgroundColor: 'elevation.surface',
	height: '100%',
	paddingBlock: 'space.600',
	paddingInline: 'space.800',
});

export const SpaceSettingsPageContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element => (
	<Box xcss={SpaceSettingsPageContainerStyles} testId={testId}>
		{children}
	</Box>
);
